import ActionTypes from "../constants/action_types";

export default function clearTopicParameters(organisationId) {
  return {
    type: ActionTypes.TOPIC_PARAMETERS_CLEAR.SUCCESS,
    organisation_id: organisationId,
  };
}
